module.exports = __webpack_public_path__ + "img/users-white.664fd044.svg";